import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { ISelectProps, SelectValueType } from 'components/uiKit/Select'
import Select from 'components/uiKit/Select'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldSelect = <V extends SelectValueType>({
  name,
  defaultValue,
  onChange,
  value,
  ...rest
}: IControlProps<ISelectProps<V>>) => {
  const onChangeWrapper = useCallback((value: V) => onChange({ name, value }), [name, onChange])
  return (
    <Select
      {...rest}
      name={name}
      onChange={onChangeWrapper}
      value={value !== undefined ? value : defaultValue}
    />
  )
}

export default FieldSelect
